import { render, staticRenderFns } from "./page-pixel.vue?vue&type=template&id=67855c2c&"
import script from "./page-pixel.vue?vue&type=script&lang=js&"
export * from "./page-pixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports